import React from "react"

const HalfFilledStar = () => {
  return (
    <div className="relative top-0 w-full h-full z-10">
      <svg
        width="11"
        height="22"
        viewBox="0 0 11 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mr-2 "
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9999 0.670912V16.6545C10.938 16.6545 10.8761 16.6736 10.8236 16.7118L4.69346 21.1656C4.45834 21.3364 4.142 21.1066 4.2318 20.8302L6.5733 13.6238C6.61346 13.5002 6.56947 13.3648 6.46432 13.2884L0.334202 8.83459C0.0990876 8.66377 0.21992 8.29189 0.510537 8.29189H8.08778C8.21775 8.29189 8.33293 8.2082 8.3731 8.08459L10.7146 0.878207C10.7595 0.74001 10.8797 0.670912 10.9999 0.670912Z"
          fill="#1D395A"
        />
      </svg>

      <div className="absolute -z-10 h-full w-1/2 -top-0 right-2.5 ">
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7147 0.878115C10.8045 0.601722 11.1955 0.601722 11.2853 0.878115L13.6268 8.0845C13.667 8.20811 13.7822 8.2918 13.9121 8.2918H21.4894C21.78 8.2918 21.9008 8.66368 21.6657 8.8345L15.5356 13.2883C15.4304 13.3647 15.3864 13.5001 15.4266 13.6237L17.7681 20.8301C17.8579 21.1065 17.5416 21.3363 17.3065 21.1655L11.1763 16.7117C11.0712 16.6353 10.9288 16.6353 10.8237 16.7117L4.69355 21.1655C4.45843 21.3363 4.14209 21.1065 4.23189 20.8301L6.57339 13.6237C6.61355 13.5001 6.56956 13.3647 6.46441 13.2883L0.334292 8.8345C0.0991777 8.66368 0.22001 8.2918 0.510627 8.2918H8.08787C8.21784 8.2918 8.33302 8.20811 8.37319 8.0845L10.7147 0.878115Z"
            fill="#BFBFBF"
          />
        </svg>
      </div>
    </div>
  )
}

export default HalfFilledStar
